import SignUpVerificationContainer from "./signup-verification.container";

export default SignUpVerificationContainer;
